module.exports = __webpack_public_path__ + "prod/1.42.2/img/third-bg-img.86e5b932.png";